import { Grid, GridItem, VStack, Show } from '@chakra-ui/react';
import type { OrderSummaryResponse } from 'api/responseTypes';
import { OrderDetails } from '../OrderDetails/OrderDetails';
import { SuccessHeader } from '../SuccessHeader/SuccessHeader';
import { TicketHolder } from '../TicketHolder/TicketHolder';
import { TicketInstruction } from '../TicketInstruction/TicketInstruction';

type OrderSummarySuccessViewProps = {
  data: OrderSummaryResponse;
};

export const OrderSummarySuccessView = ({ data }: OrderSummarySuccessViewProps) => (
  <>
    <SuccessHeader />
    <Grid
      mx='auto'
      maxW='container.xl'
      templateColumns={{ base: '1fr', md: '1fr 1fr' }}
      gap={{ base: '16px', md: '24px' }}
      p={{ base: '16px', md: '24px 16px 64px' }}
    >
      <GridItem>
        <TicketHolder tickets={data.tickets} />
      </GridItem>
      <GridItem gridRow={{ base: 1, md: 0 }}>
        <VStack gap='8px' align='stretch'>
          <OrderDetails {...data} />
          <Show above='md'>
            <TicketInstruction />
          </Show>
        </VStack>
      </GridItem>
      <Show below='md'>
        <GridItem>
          <TicketInstruction />
        </GridItem>
      </Show>
    </Grid>
  </>
);
